"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLogisticsInfoApi = getLogisticsInfoApi;
exports.integralSwitchApi = integralSwitchApi;
exports.intervalDeleteApi = intervalDeleteApi;
exports.intervalOrderDetailApi = intervalOrderDetailApi;
exports.intervalOrderListApi = intervalOrderListApi;
exports.intervalOrderMarkApi = intervalOrderMarkApi;
exports.intervalOrderNumApi = intervalOrderNumApi;
exports.intervalOrderSendApi = intervalOrderSendApi;
exports.intervalPageApi = intervalPageApi;
exports.intervalSaveApi = intervalSaveApi;
exports.intervalUpdateApi = intervalUpdateApi;
exports.offShellApi = offShellApi;
exports.orderInvoiceListApi = orderInvoiceListApi;
exports.orderInvoiceUpdateApi = orderInvoiceUpdateApi;
exports.pointsProductDetailApi = pointsProductDetailApi;
exports.productCreateApi = productCreateApi;
exports.productDeleteApi = productDeleteApi;
exports.productHeadersApi = productHeadersApi;
exports.productLstApi = productLstApi;
exports.productUpdateApi = productUpdateApi;
exports.putOnShellApi = putOnShellApi;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2024 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

/**
 * 新增商品
 * @param data
 */
function productCreateApi(data) {
  return (0, _request.default)({
    url: 'admin/platform/integral/product/save',
    method: 'POST',
    data: data
  });
}

/**
 * 编辑商品
 * @param data
 */
function productUpdateApi(data) {
  return (0, _request.default)({
    url: 'admin/platform/integral/product/update',
    method: 'POST',
    data: data
  });
}

/**
 * 商品详情
 * @param id
 */
function pointsProductDetailApi(id) {
  return (0, _request.default)({
    url: "admin/platform/integral/product/detail/".concat(id),
    method: 'GET'
  });
}

/**
 * 删除商品
 * @param id
 */
function productDeleteApi(id) {
  return (0, _request.default)({
    url: "admin/platform/integral/product/delete/".concat(id),
    method: 'post'
  });
}

/**
 * 商品列表 表头数量
 */
function productHeadersApi(params) {
  return (0, _request.default)({
    url: 'admin/platform/integral/product/tabs/headers',
    method: 'GET',
    params: params
  });
}

/**
 * 商品列表
 * @param params
 */
function productLstApi(params) {
  return (0, _request.default)({
    url: 'admin/platform/integral/product/page',
    method: 'GET',
    params: params
  });
}

/**
 * 商品上架
 * @param id
 */
function putOnShellApi(id) {
  return (0, _request.default)({
    url: "admin/platform/integral/product/update/show/".concat(id),
    method: 'post'
  });
}
/**
 * 商品下架
 * @param id
 */
function offShellApi(id) {
  return (0, _request.default)({
    url: "admin/platform/integral/product/down/".concat(id),
    method: 'post'
  });
}
/**
 * 删除积分区间
 * @param id
 */
function intervalDeleteApi(id) {
  return (0, _request.default)({
    url: "admin/platform/integral/interval/delete/".concat(id),
    method: 'post'
  });
}
/**
 * 积分区间分页列表
 * @param params
 */
function intervalPageApi(params) {
  return (0, _request.default)({
    url: "admin/platform/integral/interval/page",
    method: 'get',
    params: params
  });
}
/**
 * 新增积分区间
 * @param data
 */
function intervalSaveApi(data) {
  return (0, _request.default)({
    url: "admin/platform/integral/interval/save",
    method: 'post',
    data: data
  });
}
/**
 * 修改积分区间
 * @param data
 */
function intervalUpdateApi(data) {
  return (0, _request.default)({
    url: "admin/platform/integral/interval/update",
    method: 'post',
    data: data
  });
}
/**
 * 积分订单详情
 * @param orderNo
 */
function intervalOrderDetailApi(orderNo) {
  return (0, _request.default)({
    url: "admin/platform/integral/order/detail/".concat(orderNo),
    method: 'get'
  });
}
/**
 * 积分订单分页列表
 * @param params
 */
function intervalOrderListApi(params) {
  return (0, _request.default)({
    url: "admin/platform/integral/order/list",
    method: 'get',
    params: params
  });
}
/**
 * 积分订单备注
 * @param data
 */
function intervalOrderMarkApi(data) {
  return (0, _request.default)({
    url: "admin/platform/integral/order/mark",
    method: 'post',
    data: data
  });
}
/**
 * 积分订单发货
 * @param data
 */
function intervalOrderSendApi(data) {
  return (0, _request.default)({
    url: "admin/platform/integral/order/send",
    method: 'post',
    data: data
  });
}
/**
 * 积分订单各状态数量
 * @param params
 */
function intervalOrderNumApi(params) {
  return (0, _request.default)({
    url: "admin/platform/integral/order/status/num",
    method: 'get',
    params: params
  });
}

/**
 * 修改发货单配送信息
 * @param data
 */
function orderInvoiceUpdateApi(data) {
  return (0, _request.default)({
    url: "admin/platform/integral/order/invoice/update",
    method: 'post',
    data: data
  });
}

/**
 * 获取订单发货单列表
 * @param orderNo 订单号
 */
function orderInvoiceListApi(orderNo) {
  return (0, _request.default)({
    url: "admin/platform/integral/order/".concat(orderNo, "/invoice/list"),
    method: 'get'
  });
}

/**
 * 订单物流详情
 */
function getLogisticsInfoApi(invoiceId) {
  return (0, _request.default)({
    url: "admin/platform/integral/order/get/".concat(invoiceId, "/logistics/info"),
    method: 'get'
  });
}

/**
 * 修改积分区间状态
 */
function integralSwitchApi(id) {
  return (0, _request.default)({
    url: "admin/platform/integral/interval/update/status/".concat(id),
    method: 'post'
  });
}